"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var dateUtils_js_1 = require("./dateUtils.js");
var apiResponse_1 = require("../apiResponse");
function GetRenewals() {
    var _a;
    var _b = (0, react_1.useState)([]), renewals = _b[0], setRenewals = _b[1];
    var _c = (0, react_1.useState)(null), ministerInfo = _c[0], setMinisterInfo = _c[1];
    var _d = (0, react_1.useState)(false), loadFailed = _d[0], setLoadFailed = _d[1];
    var lang = (_a = document.documentElement.getAttribute('lang')) !== null && _a !== void 0 ? _a : 'en';
    (0, react_1.useEffect)(function () {
        axios_1.default.get('/api/ministry/renewal/list')
            .then(function (response) {
            if (!(0, apiResponse_1.isJsonSuccess)(response) || !response.data.renewals) {
                console.error('Unexpected response loading renewal list', response.status, response.data);
                setLoadFailed(true);
                return;
            }
            setRenewals(response.data.renewals);
        })
            .catch(function (error) {
            console.log(error);
            setLoadFailed(true);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        axios_1.default.get('/api/v2/students/minister/')
            .then(function (response) {
            var _a;
            if (!(0, apiResponse_1.isJsonSuccess)(response) || !((_a = response.data.minister) === null || _a === void 0 ? void 0 : _a.info)) {
                console.error('Unexpected response loading minister info', response.status, response.data);
                setLoadFailed(true);
                return;
            }
            setMinisterInfo(response.data.minister.info);
        })
            .catch(function (error) {
            console.error(error);
            setLoadFailed(true);
        });
    }, []);
    if (loadFailed)
        return react_1.default.createElement("p", null, (0, Lang_js_1.__)('Your renewals could not be loaded. Please reload the page, and sign in again if you are prompted to.'));
    if (Array.isArray(renewals) && (renewals === null || renewals === void 0 ? void 0 : renewals.length) === 0)
        return react_1.default.createElement("p", null, (0, Lang_js_1.__)('Click "Create Renewal" to create your first online renewal'));
    else if (!renewals)
        return react_1.default.createElement("p", null,
            (0, Lang_js_1.__)('Loading'),
            "...");
    if (!ministerInfo || typeof ministerInfo !== 'object')
        return react_1.default.createElement("p", null,
            (0, Lang_js_1.__)('Loading'),
            "...");
    var keys = Object.keys(ministerInfo);
    var column1Keys = keys.slice(0, Math.ceil(keys.length / 3));
    var column2Keys = keys.slice(Math.ceil(keys.length / 3), Math.ceil((2 * keys.length) / 3));
    var column3Keys = keys.slice(Math.ceil((2 * keys.length) / 3));
    return (react_1.default.createElement("div", { className: "container quotes-container renewals-container" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "renewal-legend" },
                react_1.default.createElement("h3", null, (0, Lang_js_1.__)('My Ministerial Information')),
                react_1.default.createElement("div", { className: "legend-columns" },
                    react_1.default.createElement("div", { className: "column" }, column1Keys.map(function (key) { return (react_1.default.createElement("div", { key: key, className: "legend-item" },
                        react_1.default.createElement("strong", null,
                            key,
                            ":"),
                        " ",
                        ministerInfo[key])); })),
                    react_1.default.createElement("div", { className: "column" }, column2Keys.map(function (key) { return (react_1.default.createElement("div", { key: key, className: "legend-item" },
                        react_1.default.createElement("strong", null,
                            key,
                            ":"),
                        " ",
                        ministerInfo[key])); })),
                    react_1.default.createElement("div", { className: "column" }, column3Keys.map(function (key) { return (react_1.default.createElement("div", { key: key, className: "legend-item" },
                        react_1.default.createElement("strong", null,
                            key,
                            ":"),
                        " ",
                        ministerInfo[key])); }))))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
                react_1.default.createElement(Table_1.default, { className: "table table-striped" },
                    react_1.default.createElement(TableHead_1.default, null,
                        react_1.default.createElement(TableRow_1.default, null,
                            react_1.default.createElement(TableCell_1.default, { component: "th" }, (0, Lang_js_1.__)('Credential Renewal Date')),
                            react_1.default.createElement(TableCell_1.default, { component: "th" }, (0, Lang_js_1.__)('Submitted Date')),
                            react_1.default.createElement(TableCell_1.default, { component: "th" }, (0, Lang_js_1.__)('Renewal Status')),
                            react_1.default.createElement(TableCell_1.default, { component: "th", colSpan: 2 }, (0, Lang_js_1.__)('Action')))),
                    react_1.default.createElement(TableBody_1.default, null, renewals.map(function (renewal) { return (react_1.default.createElement(TableRow_1.default, { key: renewal.id },
                        react_1.default.createElement(TableCell_1.default, { "data-title": (0, Lang_js_1.__)('Credential Renewal Date') }, (0, dateUtils_js_1.toLocaleDate)(renewal.date, lang)),
                        react_1.default.createElement(TableCell_1.default, { "data-title": (0, Lang_js_1.__)('Submitted Date') }, (0, dateUtils_js_1.toLocaleDate)(renewal.submitted_date, lang)),
                        react_1.default.createElement(TableCell_1.default, { "data-title": (0, Lang_js_1.__)('Renewal Status') },
                            react_1.default.createElement("span", { style: {
                                    display: 'inline-block',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '0.85rem',
                                    fontWeight: 600,
                                    color: renewal.status === 'submitted' ? '#fff' : renewal.status === 'deleted' ? '#999' : '#333',
                                    backgroundColor: renewal.status === 'submitted' ? '#4caf50' : renewal.status === 'deleted' ? '#eee' : '#FFFF00',
                                } }, (0, Lang_js_1.__)(renewal.status))),
                        react_1.default.createElement(TableCell_1.default, { "data-title": (0, Lang_js_1.__)('Action') },
                            (renewal.status !== 'submitted' && renewal.status !== 'deleted') && (react_1.default.createElement(Button_1.default, { variant: "contained", className: "small-button", onClick: function () { window.location.href = "/app/ministry/renewal/edit/".concat(renewal.id); } }, (0, Lang_js_1.__)('Edit'))),
                            (renewal.status !== 'submitted' && renewal.status !== 'deleted') && (react_1.default.createElement(Button_1.default, { variant: "contained", className: "small-button", onClick: function () { window.location.href = "/app/ministry/renewal/delete/".concat(renewal.id); } }, (0, Lang_js_1.__)('Delete'))),
                            (renewal.status === 'submitted') && (react_1.default.createElement(Button_1.default, { variant: "contained", className: "small-button", onClick: function () {
                                    var searchParams = new URLSearchParams(window.location.search);
                                    var isPortuguese = searchParams.get('pt') === '1';
                                    var pdfUrl = isPortuguese
                                        ? "/api/ministry/renewal/pdf?id=".concat(renewal.id, "&lang=pt")
                                        : "/api/ministry/renewal/pdf?id=".concat(renewal.id);
                                    window.open(pdfUrl, '_blank');
                                } }, (0, Lang_js_1.__)('PDF')))))); })))))));
}
exports.default = GetRenewals;
var renewalsContainer = document.getElementById('renewals-list');
if (renewalsContainer) {
    (0, mountIsland_1.mountIsland)(renewalsContainer, react_1.default.createElement(GetRenewals, null));
}
